import type { ReactElement } from 'react';
import React from 'react';
import { groupBy, sortBy } from 'lodash';
import ExternalLink from 'atom-components/external-link';
import AreaAccessProvider from 'services/providers/area-access.provider';
import AreaCard from './area-card';
import type { DashboardArea } from './types';
import './teacher-dashboard.scss';

type Props = {
  areas: DashboardArea[];
};

const getTitle = (title: string): string | null => {
  switch (title) {
    case 'assessment':
      return 'Assessments';
    case 'survey':
      return 'Surveys';
    default:
      return null;
  }
};

export default function TeacherDashboard({ areas }: Props): ReactElement {
  const sortedAreas = sortBy(areas, (a) => !a.isActive);
  const groupedAreas = groupBy(sortedAreas, 'type');

  return (
    <div>
      {Object.keys(groupedAreas).map((key) => {
        const areasByType = groupedAreas[key];
        const title = getTitle(key);

        return (
          <div key={`category-${key}`} className="category">
            <h1 className="category-name">{title}</h1>
            <div className="area-wrapper">
              {areasByType.map((area) => (
                <AreaAccessProvider key={area.id} areaId={area.id}>
                  <AreaCard area={area} />
                </AreaAccessProvider>
              ))}
            </div>
          </div>
        );
      })}
      <div className="category">
        <h1 className="category-name">Resources</h1>
        <div className="area-wrapper">
          <div data-theme="arbs" className="card area-card">
            <ExternalLink className="text-body h-100" href="https://arbs.nzcer.org.nz">
              <h5 className="card-title m-auto p-1">Assessment Resource Bank</h5>
            </ExternalLink>
          </div>
          <div data-theme="nzcer" className="card area-card">
            <ExternalLink className="text-body h-100" href="https://www.nzcer.org.nz/pld">
              <h5 className="card-title m-auto p-1">NZCER Workshops</h5>
            </ExternalLink>
          </div>
          <div data-theme="tsp" className="card area-card">
            <ExternalLink className="text-body h-100" href="https://www.tspsurveys.org.nz">
              <h5 className="card-title h6 m-auto p-1">
                Teaching, School, and Leadership Practices Survey
              </h5>
              <hr />
              <span>Now available for terms 2 & 3</span>
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
  );
}
